import { useTranslation } from "react-i18next";
import { ABOAWARD_TOSTR } from "../../../Lit/acc-es-data/src/enums/aboAwardLevels";
import defaultAwardContent from "../../../../content/awardLabels";
import { RequalifiedBadgeTile } from "../../../../common/components/RequirementTiles/RequalifiedBadgeTile/RequalifiedBadgeTile";
import type { LSPathRequalifiedBadgeRequirement } from "../../../../services/LeadershipSeminar/leadershipSeminarAPI.types";
import { getPerformanceYearShort } from "../../../../common/util/period";
import "./LSRequalifiedBadgeTile.scss";

export interface LSRequalifiedBadgeTileProps {
  requirement: LSPathRequalifiedBadgeRequirement;
  selectedPeriod: number;
}

export const LSRequalifiedBadgeTile = ({ requirement, selectedPeriod }: LSRequalifiedBadgeTileProps) => {
  const { t } = useTranslation(["common"]);

  // Resolve pin display name: numeric rank -> dashed string -> i18n display name
  const dashedRank = ABOAWARD_TOSTR[requirement.TrackingAwardRank] ?? "not-available";
  const rankDisplayName = String(
    t(
      `awardLabels.${dashedRank}`,
      (defaultAwardContent.awardLabels as Record<string, string>)[dashedRank] ?? dashedRank,
    ),
  );

  // Get performance year from selected period (e.g., 202609 -> PY27)
  const performanceYear = `PY${getPerformanceYearShort(selectedPeriod)}`;

  return (
    <div className="LSRequalifiedBadgeTile">
      <RequalifiedBadgeTile
        requirement={requirement}
        performanceYear={performanceYear}
        rankDisplayName={rankDisplayName}
      />
    </div>
  );
};
